import React, { useEffect, useRef, useState } from 'react';
import './stepper.scss';


  const Stepper = (props) => {
    const {
        current,
        steps,
      } = props;


    const colorStepStyle=(stepId,current)=>{
        if(stepId < current)
            return "stepper__row-item-checked";
        else if(stepId==current)
            return "stepper__row-item-active";
        else
            return "stepper__row-item";
    }
    return (<div className={`stepper__row-container text-dark`}>
            {steps && steps.map((item)=>{
                return (<div id={item.id} key={item.id} className={`stepper__row-item `+colorStepStyle(item.id,current)}>
                    <div className={`stepper__number`}>
                        <div className={(item.id<=current?`stepper__number-badge-active`:`stepper__number-badge`)}>
                            {item.id}
                        </div>   
                        <div>{item.name}</div> 
                    </div>
                </div>)
            })}
            </div>
    )
}

export default Stepper;
